const sharedSummaryTabStyles = {
  fontSize: '0.88rem',
  fontWeight: 400,
  textTransform: 'none',
  borderRadius: 40,
  marginRight: 10,
  padding: '0px 20px',
  width: 'auto',
  height: 37,
  ['@media all and (max-width:1300px)']: { // eslint-disable-line no-useless-computed-key
    display: 'none'
  }
}

export { sharedSummaryTabStyles }



// WEBPACK FOOTER //
// ./src/styles/tabs/styles.js